import { css } from "@emotion/react";

import { colors } from "@styles";

export const flag = css`
  width: 1.125rem;
  margin-right: 0.5rem;
`;

export const activeButton = css`
  border-color: ${colors.info};
  border-width: 2px;
  border-style: solid;
`;
